import React from 'react';

export const Banner00DataSource = {
  wrapper: { className: 'banner0 kmvfwxsfl2-editor_css' },
  textWrapper: { className: 'banner0-text-wrapper' },
  title: {
    className: 'banner0-title l5lvzja6inq-editor_css',
    children: '',//'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/3a78c49c-0a17-4725-b2bb-48a88387ecf8.png',
  },
  content: {
    className: 'banner0-content',
    children: (
      <span>
        {/* <p>江西融云网路科技有限公司，是一家专注于政务软件开发、销售服务一体的公司，主要面向政府部门、事业单位、非营利组织的全方位业务管理信息化解决方案提供商，集款件开发、销售服务于一体。</p> */}
      </span>
    ),
  },
  button: { className: 'banner0-button', children: '' },
};
export const Content00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper l5q5bzt3r28-editor_css',
  },
  page: { className: 'home-page home-hydt-page content0 l5q5cs9po6g-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <h4>行业动态</h4>
            </span>
            <div style={{color: 'rgba(0, 0, 0, 0.65)',fontSize:'16px',marginTop:'12px'}}>用我的专业，成就你的将来，热点资讯，掌握这些就够了</div>
          </span>
        ),
        className: 'l5q5a3rw0c-editor_css',
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper l5q5agveag7-editor_css',
    children: [
      {
        name: 'block0',
        className: '',
        md: 0,
        xs: 24,
        children: {
          className: '',
          children: [
           
          ],
        },
      },
    ],
  },
};
export const Feature11DataSource = {
  wrapper: { className: 'home-page-wrapper content-1-wrapper' },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children:
      require('../static/hover/热点咨询.jpg'),
    className: 'l5q5epltx4j-editor_css',
  },
  textWrapper: { className: 'content1-text', md: 14, xs: 24 },
  title: { className: 'content1-title', children: '企业资源管理' },
  content: {
    className: 'content1-content',
    children:
      '云资源集中编排、弹性伸缩、持续发布和部署，高可用及容灾。云资源集中编排、弹性伸缩、持续发布和部署，高可用及容灾。云资源集中编排、弹性伸缩、持续发布和部署，高可用及容灾。',
  },
};
export const Content30DataSource = {
  wrapper: { className: 'home-page-wrapper content3-wrapper' },
  page: { className: 'home-page content3' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>解决方案</p>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: (
          <span>
            <span>
              <p>基于融云强大的基础资源</p>
            </span>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/ScHBSdwpTkAHZkJ.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <span>
                  <p>教育行业</p>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <p>
                  通过信息化手段，将学校管理过程优化协调，实现校园内各类资源的有效集成、整合，提高教育软硬件设备的配置和利用率，构建智慧物联的数字校园。
                </p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block1',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>政府行业</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <span>
                  <p>
                    &nbsp;充分利用物联网、云计算、大数据分析、移动互联网等新一代信息技术，以用户创新、大众创新、开放创新、共同创新为特征，强调作为平台的政府架构，并以此...
                  </p>
                  <p />
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block2',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>服务行业</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children:
              '分布式云环境集中监控，统一资源及应用状态视图，智能分析及故障定位。',
          },
        },
      },
      {
        name: 'block3',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>企业行业</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children:
              '一站式移动金融APP开发及全面监控；丰富可用组件，动态发布和故障热修复。',
          },
        },
      },
      {
        name: 'block4',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/UsUmoBRyLvkIQeO.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>第三方服务行业</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children:
              '金融级联机交易处理中间件，大规模分布式计算机，数万笔/秒级并发能力，严格保证交易数据统一性。',
          },
        },
      },
      {
        name: 'block5',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/ipwaQLBLflRfUrg.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>互联网+大数据</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children:
              '一站式、全周期大数据协同工作平台，PB级数据处理、毫秒级数据分析工具。',
          },
        },
      },
    ],
  },
};
export const Teams30DataSource = {
  wrapper: { className: 'home-page-wrapper teams3-wrapper' },
  page: { className: 'home-page teams3' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>公司荣誉</p>
          </span>
        ),
      },
    ],
  },
  blockTop: {
    className: 'block-top-wrapper',
    children: [
      {
        name: 'block0',
        className: 'block-top',
        md: 6,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams3-top-image',
              children:   'http://www.rongyungov.com/images/zhengshu/高新技术企业证书.jpg',
            },
            {
              name: 'title',
              className: 'teams3-top-title',
              children: (
                <span>
                  <p>高新技术企业证书</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams3-top-job',
              children: '高新技术企业证书',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block-top',
        md: 6,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams3-top-image',
              children:
                'http://www.rongyungov.com/images/zhengshu/双软认证.jpg',
            },
            {
              name: 'title',
              className: 'teams3-top-title',
              children: (
                <span>
                  <p>双软认证</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams3-top-job',
              children: '公司+职位 信息暂缺',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block-top',
        md: 6,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams3-top-image',
              children:
                'http://www.rongyungov.com/images/zhengshu/双软认证2.jpg',
            },
            {
              name: 'title',
              className: 'teams3-top-title',
              children: (
                <span>
                  <p>双软认证2</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams3-top-job',
              children: '双软认证2',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block-top',
        md: 6,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams3-top-image',
              children:
                'http://www.rongyungov.com/images/zhengshu/水闸集群远程监测管理系统.jpg',
            },
            {
              name: 'title',
              className: 'teams3-top-title',
              children: (
                <span>
                  <p>水闸集群远程监测管理系统</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams3-top-job',
              children: '水闸集群远程监测管理系统',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block-top',
        md: 6,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams3-top-image',
              children:
                'http://www.rongyungov.com/images/zhengshu/Excel考训.jpg',
            },
            {
              name: 'title',
              className: 'teams3-top-title',
              children: (
                <span>
                  <p>Excel考训</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams3-top-job',
              children: 'Excel考训',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block-top',
        md: 6,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams3-top-image',
              children:
                'http://www.rongyungov.com/images/zhengshu/农村集体产权交易系统.jpg',
            },
            {
              name: 'title',
              className: 'teams3-top-title',
              children: (
                <span>
                  <p>农村集体产权交易系统</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams3-top-job',
              children: '农村集体产权交易系统',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block-top',
        md: 6,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams3-top-image',
              children:
                'http://www.rongyungov.com/images/zhengshu/融云财务通用凭证数据导入程序软件.jpg',
            },
            {
              name: 'title',
              className: 'teams3-top-title',
              children: (
                <span>
                  <p>融云财务通用凭证数据导入程序软件</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams3-top-job',
              children: '融云财务通用凭证数据导入程序软件',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block-top',
        md: 6,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams3-top-image',
              children:
                'http://www.rongyungov.com/images/zhengshu/融云财政预算指标管理系统.jpg',
            },
            {
              name: 'title',
              className: 'teams3-top-title',
              children: (
                <span>
                  <p>融云财政预算指标管理系统</p>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams3-top-job',
              children: '融云财政预算指标管理系统',
            },
          ],
        },
      },
      
    ],
  },
  block: {
    className: 'block-wrapper l5q5uxcyz3f-editor_css',
    gutter: 72,
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 8,
        xs: 24,
        image: {
          name: 'image',
          className: 'teams3-image',
          children:
            'http://www.rongyungov.com/images/zhengshu/高新技术企业证书.jpg',
        },
        titleWrapper: {
          className: 'teams3-textWrapper',
          children: [
            { name: 'title', className: 'teams3-title', children: '叶秀英' },
            {
              name: 'content',
              className: 'teams3-job',
              children: '公司+职位 信息暂缺',
            },
            {
              name: 'content1',
              className: 'teams3-content',
              children: 'AntV 是蚂蚁金服全新一代数据可视化解决方案。',
            },
          ],
        },
      },
    ],
  },
};
export const Feature00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper l5knejpv4lh-editor_css',
  },
  page: { className: 'home-page content0 l5knf5r0c76-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>公司介绍</p>
          </span>
        ),
        className: 'l5knf56gysc-editor_css',
      },
      {
        name: 'content~l5knirex8zp',
        className: '',
        children: (
          <span>
            <span>
              <p>Company Introduction</p>
            </span>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper l5kneh7i0vc-editor_css',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/WBnVOjtIlGWbzyQivuyq.png',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/YPMsLQuCEXtuEkmXTTdk.png',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block l5kne4ltkyb-editor_css',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/EkXWVvAaFJKCzhMmQYiX.png',
            },
          ],
        },
      },
    ],
  },
};
export const Feature10DataSource = {
  wrapper: {
    className: 'home-page-wrapper content1-wrapper l5q5wklov4-editor_css gsry-editor_css',
  },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children:
      require('../static/组建/组 29.png'),
    className: 'l5knrm24kps-editor_css',
  },
  textWrapper: {
    className: 'content1-text l5kn25rnmcm-editor_css',
    md: 14,
    xs: 24,
  },
  title: {
    className: 'content1-title l5kn1r2a65t-editor_css',
    children: '企业资源管理',
  },
  content: {
    className: 'content1-content',
    children: (
      <span>
        <p>
          江西融云网络科技有限公司，是一家专注于政务软件开发、销售、服务一体的公司，主要面向政府部门、事业单位、非营利组织的全方位业务管理信息化解决方案提供商。
        </p>
        <p>
          <br />公司的业务涵盖：财政、水利、高校、银行、税务、民生、公检法等行业。
        </p>
        <p>
          <br />核心产品和服务包括：水闸群远程监测管理项目方案、水文立杆监测项目方案、大数据产品、财政预算指标一体化解决方案、智慧统战方案、银行代理财政业务、公共资源交易中心投标保证金跨银行管理方案、行政事业单位内控信息化解决方案、基建项目库项目等。<br />
        </p>
      </span>
    ),
  },
};
export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/6c9590b0-0bd3-4643-bc8d-91b3dcfceca6.png',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>江西融云网络科技有限公司</p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <span>
                <span>
                  <p>行业动态</p>
                </span>
              </span>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '#',
              children: (
                <span>
                  <p>咨询中心</p>
                </span>
              ),
            },
            {
              name: 'link1',
              href: '#',
              children: (
                <span>
                  <p>解决方案</p>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '#',
              children: (
                <span>
                  <p>产品服务</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>友情链接</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: 'http://shyy.chinaetax.com.cn/',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <p>用友政务</p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~l5kogbtn5oe',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>联系我们</p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '#',
              children: (
                <span>
                  <span>
                    <span>
                      <p>公司地址：江西省九江市濂溪区十里老街C4栋4层1499号</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              name: 'link1',
              href: '#',
              children: (
                <span>
                  <span>
                    <p>邮编：320000</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '#',
              children: (
                <span>
                  <span>
                    <p>联系电话：0972-8159222</p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>©2018 by 江西融云网络科技有限公司&nbsp;|&nbsp;</span>赣ICP备19005035号-1&nbsp;
      </span>
    ),
  },
};
